export function cleanEmptyProps(object: {
  [prop: string]: string | string[] | boolean | number | null | undefined;
}): { [prop: string]: string | string[] | boolean | number } {
  if (!object) {
    return null;
  }
  return Object.fromEntries(Object.entries(object).filter(([, v]) => !!v));
}
// A função cleanEmptyProps converte um objeto JavaScript em uma string de consulta (query string) para uso em URLs. Aqui está um resumo do que ela faz:

// Obtém as chaves do objeto.
// Cria pares chave-valor codificados com encodeURIComponent.
// Une os pares com & para formar a query string.
